import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import type { ScrollController } from "@/app/scroll";

gsap.registerPlugin(ScrollTrigger);

const RING_FADE_DISTANCE = 48;

export class HeaderProgressController {
  readonly #logo: HTMLElement;
  readonly #scroll: ScrollController;
  #trigger?: ScrollTrigger;
  #unsubscribeScroll?: () => void;

  constructor(logo: HTMLElement, scroll: ScrollController) {
    this.#logo = logo;
    this.#scroll = scroll;
  }

  mount(): void {
    if (this.#trigger) return;
    this.#unsubscribeScroll = this.#scroll.on("scroll", ScrollTrigger.update);
    this.#trigger = ScrollTrigger.create({
      start: 0,
      end: "max",
      id: "header-scroll-progress",
      onUpdate: (trigger) => this.#render(trigger),
      onRefresh: (trigger) => this.#render(trigger),
    });
    this.#trigger.refresh();
  }

  refresh(): void {
    this.#trigger?.refresh();
  }

  destroy(): void {
    this.#unsubscribeScroll?.();
    this.#unsubscribeScroll = undefined;
    this.#trigger?.kill();
    this.#trigger = undefined;
    this.#logo.style.removeProperty("--header-logo-active");
    this.#logo.style.removeProperty("--header-logo-progress");
  }

  #render(trigger: ScrollTrigger): void {
    const scroll = Math.max(0, trigger.scroll());
    const scrollRange = Math.max(0, trigger.end - trigger.start);
    const progress = scrollRange > 0 ? gsap.utils.clamp(0, 1, trigger.progress) : 0;
    const active = gsap.utils.clamp(0, 1, scroll / RING_FADE_DISTANCE);
    this.#logo.style.setProperty("--header-logo-active", active.toFixed(4));
    this.#logo.style.setProperty("--header-logo-progress", progress.toFixed(4));
  }
}
